// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_o1-0";
export var discountCodeInput = "_o1-1";